// Generated by purs version 0.13.0
"use strict";
var Chip_Model_SwitchState = require("../Chip.Model.SwitchState/index.js");
var Chip_Model_Tile = require("../Chip.Model.Tile/index.js");
var toggleWall = function (v) {
    if (v instanceof Chip_Model_Tile.SwitchableWall && v.value0 instanceof Chip_Model_SwitchState.On) {
        return new Chip_Model_Tile.SwitchableWall(Chip_Model_SwitchState.Off.value);
    };
    if (v instanceof Chip_Model_Tile.SwitchableWall && v.value0 instanceof Chip_Model_SwitchState.Off) {
        return new Chip_Model_Tile.SwitchableWall(Chip_Model_SwitchState.On.value);
    };
    return v;
};
module.exports = {
    toggleWall: toggleWall
};
